module.exports = __webpack_public_path__ + "img/golden_line_up@3x.14e96663.png";